<template>
  <div class="home-last-lesson-slide py-4 py-md-0">
    <router-link :to="to">
      <div :style="imgStyle" class="img">
        <div class="progress-wrapper">
          <div class="progress-bar" :style="progressStyle"></div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    progress: Object
  },
  computed: {
    imgStyle() {
      const url = this.progress.resource.picture
        ? this.progress.resource.picture
        : this.progress.lesson.ca_cover;
      return { "background-image": `url(${url})` };
    },
    progressStyle() {
      return {
        width:
          (100 * this.progress.stopped_at) /
            this.progress.resource.total_duration +
          "%"
      };
    },
    to() {
      const name = this.progress.lesson.trail ? "trail-lesson" : "lesson";
      return {
        name,
        params: {
          trail: this.progress.lesson.trail,
          ...this.progress.lesson
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.home-last-lesson-slide {
  .img {
    width: 100%;
    padding-bottom: 56%;
    height: 0;
    border-radius: 3px;
    background-size: cover;
    background-position: center center;
  }

  a {
    font-size: 14px;
  }

  .progress-wrapper {
    height: 5px;
    border-radius: 5px;
    background: #bbbbbb;
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 8px;
    width: calc(100% - 16px);

    .progress-bar {
      height: 5px;
      border-radius: 5px;
      background: #fb263e;
    }
  }
}
</style>
